import { render, staticRenderFns } from "./WNotification.vue?vue&type=template&id=28da85e4&scoped=true&lang=pug&"
import script from "./WNotification.vue?vue&type=script&lang=js&"
export * from "./WNotification.vue?vue&type=script&lang=js&"
import style0 from "./WNotification.vue?vue&type=style&index=0&id=28da85e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28da85e4",
  null
  
)

export default component.exports